import { call, put, takeEvery } from "redux-saga/effects"

import { GET_COURSE_UNITS, ADD_NEW_COURSE_UNIT, UPDATE_COURSE_UNIT, DELETE_COURSE_UNIT } from "./actionTypes";
import {
    getCourseUnitsSuccess,
    getCourseUnitsFail,
    addCourseUnitSuccess,
    addCourseUnitFail,
    updateCourseUnitSuccess,
    updateCourseUnitFail,
    deleteCourseUnitSuccess,
    deleteCourseUnitFail,
   
} from "./actions"

import {
    getCourseUnits,
    addNewCourseUnit,
    updateCourseUnit,
    deleteCourseUnit,
   
} from "helpers/course-units/course_units_backend_helper";
import { toast } from "react-toastify";

function* fetchCourseUnits() {
    try {
        const response = yield call(getCourseUnits)

        console.log("RESPONSE ON GET: ", response);
        yield put(getCourseUnitsSuccess(response))
    } catch (error) {
        yield put(getCourseUnitsFail(error))
    }
}

function* onAddNewCourseUnit({ payload }) {
    try {

        
        const response = yield call(addNewCourseUnit, payload)

        console.log("RESPONSE:", response);
        yield put(addCourseUnitSuccess(response.courseUnit))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addCourseUnitFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateCourseUnit({ payload: data }) {
    try {
        const response = yield call(updateCourse, data)
        yield put(updateCourseUnitSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateCourseUnitFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateCourseUnit({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateCourseUnit, payload)
        yield put(updateCourseUnitSuccess(response.courseUnit))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateCourseUnitFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteCourseUnit({ payload: data }) {

    try {
        const response = yield call(deleteCourseUnit, data)
        yield put(deleteCourseUnitSuccess(response.courseUnitId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteCourseUnitFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* courseUnitSaga() {
    yield takeEvery(GET_COURSE_UNITS, fetchCourseUnits)
    yield takeEvery(ADD_NEW_COURSE_UNIT, onAddNewCourseUnit)
    yield takeEvery(UPDATE_COURSE_UNIT, onUpdateCourseUnit)
    yield takeEvery(DELETE_COURSE_UNIT, onDeleteCourseUnit)
}

export default courseUnitSaga;